import { Separator } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import Image from 'components/LegacyImage'
import Link from 'components/Link'
import { useCourseBySlug } from 'libs/client/api'
import { coursePath } from 'libs/paths'

const FeaturedInstructor = () => {
  const { t } = useTranslation('@mc/next')
  const { article } = useStaticData()
  const { courseBySlug } = useCourseBySlug(article.featuredCourseSlug)

  return (
    <section className='container'>
      <Separator className='mc-separator mc-mt-0' />
      <div className='row mc-my-10 mc-text--center mc-text-sm--left'>
        <div className='col-12 col-sm-3 col-md-2'>
          <Image
            alt=''
            className='mc-corners--circle'
            height={128}
            src={courseBySlug.primary1x1}
            width={128}
          />
        </div>
        <div className='col-12 col-sm-9 col-md-10'>
          <p className='mc-text--bold mc-opacity--muted mc-text--uppercase mc-text-small mc-mb-2'>
            {t('article.featuredInstructor.title')}
          </p>
          <h2 className='mc-text--bold mc-text--uppercase mc-text-h4 mc-mb-4'>
            {courseBySlug.instructorName}
          </h2>
          <p className='mc-mb-6'>{courseBySlug.marketingCmColumn}</p>
          <Link
            className='c-button c-button--tertiary'
            href={coursePath(courseBySlug.slug)}
            passHref
          >
            {t('article.featuredInstructor.cta')}
          </Link>
        </div>
      </div>
      <Separator className='mc-separator mc-my-0' />
    </section>
  )
}

export default FeaturedInstructor
